// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"35543b5e","642":"c6881e4c"}[chunkId] + ".chunk.js";
};